import { http, httpToken } from "@/utils/http";
import qs from "qs";

// let msgbox = require('element-ui')

// 获取百度api认证token
export async function getBaiduToken() {
  let token
  await http({
    url: '/lpr/token',
    method: 'get'
  }).then(res => {
    token = JSON.parse(res.data.msg).refresh_token
  })
  return token
}

// 车牌号识别
export async function numberRecognition(token, imageUrl) {
  let carNumber = ''
  await http({
    url: '/lpr/recognition',
    method: 'post',
    data: {
      access_token: token,
      imageUrl: imageUrl,
    }
  }).then(res => {
    if (JSON.parse(res.data.msg).error_code === 282103) {
      // msgbox.Message.error('未识别出车牌，请手动选择车牌')
    } else {
      if (JSON.parse(res.data.msg).words_result.number) {
        carNumber = JSON.parse(res.data.msg).words_result.number
        // msgbox.Message.error('车牌识别成功')
      }
    }

  }).catch(() => {
    // msgbox.Message.error('车牌识别出错')
  })
  return carNumber
}

// 获取所有启用仓房
export function getWarehouse(val, is) {
  let paramData = [{ column: "unit", type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId }];
  let array = []
  httpToken({
    url: '/barnInfo/allNo',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData),
    })
  }).then(res => {
    let warehouseList = res.data.data
    if (val === 'id') {
      warehouseList.forEach((item) => {
        array.push({ 'label': item.barName, 'value': item.id, })
      })
    } else if (val === 'name') {
      warehouseList.forEach((item) => {
        array.push({ 'label': item.barName, 'value': item.barName, })
      })
    } else if (val === 'rtu') {
      warehouseList.forEach((item) => {
        if (item.rtu) {
          array.push({ 'label': item.barName, 'value': item.rtu, })
        }
      })
    } else if (val === 'rtuAll'){
      warehouseList.forEach((item) => {
        if (item.rtu) {
          array.push({ 'label': item.barName, 'value': item, })
        }
      })
    }
    if (is) {
      array.unshift({ 'label': '全部', 'value': null, })
    }
  })
  return array
}

// 获取所有仓房包括sons
export function getBarnInfoAllSons(param) {
  let paramData = [
    { column: "unit", type: "eq", value: JSON.parse(sessionStorage.getItem('user')).unitId },
    { column: "bar_status", type: "eq", value: '启用' }
  ]
  if (param) {
    paramData.push(param)
  }
  let array = []
  httpToken({
    method: "post",
    url: "/barnInfo/allSons",
    data: qs.stringify({ paramData: JSON.stringify(paramData), }),
  }).then((res) => {
    if (res.data.code === 200) {
      let barnList = res.data.data
      barnList.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.barName, 'value': item.id, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.id, })
        }
      })
    }
  })
  return array;
}

// 获取所有粮食品种
export function getGrainKindDictionary(val) {
  let json = [{ "column": "type_name", "type": "eq", "value": "grainKind" }, { "column": "sort", "type": "orderByAsc" }]
  let array = [];
  httpToken({
    method: "post",
    url: "/maintain/data-dictionary/allSons",
    data: qs.stringify({
      'paramData': JSON.stringify(json)
    }),
  }).then((res) => {
    let resData = res.data.data;
    if (!val) {
      resData.forEach((item) => {
        let children = []
        if (item.children !== null) {
          item.children.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.name })
          })
          array.push({ 'label': item.name, 'value': item.name, children: children })
        } else {
          array.push({ 'label': item.name, 'value': item.name, })
        }
      })
    } else if (val === 'id') {
      resData.forEach((item) => {
        let children = []
        if (item.children !== null) {
          item.children.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.name, 'value': item.id, children: children })
        } else {
          array.push({ 'label': item.name, 'value': item.id, })
        }
      })
    }
  })
  return array;
}
export function getGrainKindDictionaryThen(val) {
  let json = [{ "column": "type_name", "type": "eq", "value": "grainKind" }, { "column": "sort", "type": "orderByAsc" }]
  return httpToken({
    method: "post",
    url: "/maintain/data-dictionary/allSons",
    data: qs.stringify({
      'paramData': JSON.stringify(json)
    }),
  }).then((res) => {
    let array = [];
    let resData = res.data.data;
    if (!val) {
      resData.forEach((item) => {
        let children = []
        if (item.children !== null) {
          item.children.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.name })
          })
          array.push({ 'label': item.name, 'value': item.name, children: children })
        } else {
          array.push({ 'label': item.name, 'value': item.name, })
        }
      })
    } else if (val === 'id') {
      resData.forEach((item) => {
        let children = []
        if (item.children !== null) {
          item.children.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.name, 'value': item.id, children: children })
        } else {
          array.push({ 'label': item.name, 'value': item.id, })
        }
      })
    }
    return array;
  })
}
// 入库根据粮食品种获取所有启用仓房
export function getGranaryIn(grainKind, istype) {
  let array = []
  httpToken({
    url: '/dropDown/barnInfoTwo',
    method: 'post',
    data: qs.stringify({ grainKind: grainKind })
  }).then(res => {
    let warehouseList = res.data.data
    if (istype === 2) {
      warehouseList.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.barNumber })
          })
          array.push({ 'label': item.barName, 'value': item.barNumber, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.barNumber, })
        }
      })
    } else {
      warehouseList.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.barName, 'value': item.id, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.id, })
        }
      })
    }

  })
  return array
}

// 出库根据粮食品种获取所有启用仓房
export function getGranaryOut(grainKind, istype) {
  let array = []
  httpToken({
    url: '/dropDown/barnInfoTwo2',
    method: 'post',
    data: qs.stringify({ grainKind: grainKind })
  }).then(res => {
    let warehouseList = res.data.data
    if (istype === 2) {
      warehouseList.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.barNumber })
          })
          array.push({ 'label': item.barName, 'value': item.barNumber, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.barNumber, })
        }
      })
    } else {
      warehouseList.forEach((item) => {
        let children = []
        if (item.sons !== null) {
          item.sons.forEach((item2) => {
            children.push({ 'label': item2.name, 'value': item2.id })
          })
          array.push({ 'label': item.barName, 'value': item.id, children: children })
        } else {
          array.push({ 'label': item.barName, 'value': item.id, })
        }
      })
    }
  })
  return array
}

// 获取入库每个阶段的车牌号列表
export function carWaitIn(stage) {
  let carNumberList = []
  httpToken({
    url: '/warehousing/wait',
    method: 'post',
    data: qs.stringify({ number: stage })
  }).then(res => {
    if (res.data.code === 200) {
      if (res.data.data !== null) {
        const carList = res.data.data
        for (let a = 0; a < carList.length; a++) {
          carNumberList.push({ value: carList[a] })
        }
      }
    }
  })
  return carNumberList
}

// 获取出库每个阶段的车牌号列表
export function carWaitOut(stage) {
  let carNumberList = []
  httpToken({
    url: '/exWarehousing/wait',
    method: 'post',
    data: qs.stringify({ number: stage })
  }).then(res => {
    const carList = res.data.data
    for (let a = 0; a < carList.length; a++) {
      carNumberList.push({ value: carList[a] })
    }
  })
  return carNumberList
}

// 获取移库移入每个阶段的车牌号列表
export function carWaitIn1(stage) {
  let carNumberList = []
  httpToken({
    url: '/warehousing/wait1',
    method: 'post',
    data: qs.stringify({ number: stage })
  }).then(res => {
    const carList = res.data.data
    for (let a = 0; a < carList.length; a++) {
      carNumberList.push({ value: carList[a] })
    }
  })
  return carNumberList
}
// 获取入库化验阶段的流水号与车牌号列表
export function carWaitIn2() {
  let carNumberList = []
  httpToken({
    url: '/warehousing/examine/wait',
    method: 'post',
  }).then(res => {
    const carList = res.data.data
    for (let a = 0; a < carList.length; a++) {
      // carNumberList.push({value: carList[a].carSheepNumber,label:carList[a].carSheepNumber+'--'+carList[a].inOutNumber||'出入库流水号缺失'})
      carNumberList.push({ value: carList[a].carSheepNumber, label: carList[a].inOutNumber || '出入库流水号缺失' })
    }
  })
  return carNumberList
}

// 获取移库移出每个阶段的车牌号列表
export function carWaitOut1(stage) {
  let carNumberList = []
  httpToken({
    url: '/exWarehousing/wait1',
    method: 'post',
    data: qs.stringify({ number: stage })
  }).then(res => {
    const carList = res.data.data
    for (let a = 0; a < carList.length; a++) {
      carNumberList.push({ value: carList[a] })
    }
  })
  return carNumberList
}

// 身份证校验
export function checkIdcard(idcard) {

  const Errors = ["0",
    "身份证号码位数不对!",
    "身份证号码出生日期超出范围或含有非法字符!",
    "身份证号码校验错误!",
    "身份证地区非法!"];
  const area = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };

  // const idcard
  let Y, JYM
  let S, M, ereg;
  let idcard_array;
  idcard_array = idcard.split("");
  //地区检验
  if (area[parseInt(idcard.substr(0, 2))] == null) return Errors[4];
  //身份号码位数及格式检验
  switch (idcard.length) {
    case 15:
      if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)) {
        ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; //测试出生日期的合法性
      } else {
        ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; //测试出生日期的合法性
      }
      if (ereg.test(idcard)) return Errors[0];
      else return Errors[2];
    case 18:
      //18位身份号码检测
      //出生日期的合法性检查
      //闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
      //平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
      if (parseInt(idcard.substr(6, 4)) % 4 === 0 || (parseInt(idcard.substr(6, 4)) % 100 === 0 && parseInt(idcard.substr(6, 4)) % 4 === 0)) {
        ereg = /^[1-9][0-9]{5}19|20[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; //闰年出生日期的合法性正则表达式
      } else {
        ereg = /^[1-9][0-9]{5}19|20[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; //平年出生日期的合法性正则表达式
      }
      if (ereg.test(idcard)) { //测试出生日期的合法性
        //计算校验位
        S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
        Y = S % 11;
        M = "F";
        JYM = "10X98765432";
        M = JYM.substr(Y, 1); //判断校验位
        if (M === idcard_array[17]) return Errors[0]; //检测ID的校验位
        else return Errors[3];
      } else return Errors[2];
    default:
      return Errors[1];
  }
}

// 入库获取车辆在某阶段详细数据
export function carChooseIn(carNumber, stage, callback) {
  httpToken({
    url: '/warehousing/choose',
    method: 'post',
    data: qs.stringify({
      carSheepNumber: carNumber,
      number: stage
    })
  }).then(res => {
    callback(res)
  }).catch((error) => {
    console.error(error)
  })
}

// 出库获取车辆在某阶段详细数据
export function carChooseOut(carNumber, stage, callback) {
  httpToken({
    url: '/exWarehousing/choose',
    method: 'post',
    data: qs.stringify({
      carSheepNumber: carNumber,
      number: stage
    })
  }).then(res => {
    callback(res)
  }).catch((error) => {
    console.error(error)
  })
}

// 获取发货单位的下拉选项
export function companyOptions(type = 1) {
  let companyList = []
  let paramData=[{column: "company_status", type: 'eq', value: '1'}]
  httpToken({
    url: 'companyInfo/all',
    method: 'post',
    data: qs.stringify({
      paramData: JSON.stringify(paramData)
    })
  }).then(res => {
    let company = res.data.data
    if (type == 1) {
      for (let i = 0; i < company.length; i++) {
        companyList.push({
          value: company[i].comNumber,
          label: company[i].companyName
        })
      }
    } else if (type == 2) {
      for (let i = 0; i < company.length; i++) {
        companyList.push({
          value: company[i].companyName,
          label: company[i].companyName
        })
      }
    }
  })
  return companyList
}

// 获取通知单的下拉选项，'0'为入库，'1'为出库
export function messageOptions(type, labeltype = 1,url='/dropDown/notice') {
  let noticeList = []
  httpToken({
    url: url,
    method: 'post',
    data: qs.stringify({ type: type })
  }).then(res => {
    let notice = res.data.data
    if (labeltype == 2) {
      for (let i = 0; i < notice.length; i++) {
        let foodNaturelabel=notice[i].foodNature||'粮食性质暂无'
        let grainBelonglabel=notice[i].grainBelong||'粮食性质暂无'
        let grainLevellabel=notice[i].grainLevel||'粮食性质暂无'
        noticeList.push({
          value: notice[i].id,
          label: notice[i].number + '-' + notice[i].barnName + '-' + notice[i].grainKind + '-' + foodNaturelabel + '-' + grainBelonglabel + '-' + grainLevellabel + '-' + (notice[i].primitiveNumber / 1000) + '吨',
          actualNumber: notice[i].actualNumber,
          primitiveNumber: notice[i].primitiveNumber,
        })
      }
    } else {
      for (let i = 0; i < notice.length; i++) {
        let foodNaturelabel=notice[i].foodNature||'粮食性质暂无'
        let grainBelonglabel=notice[i].grainBelong||'粮食性质暂无'
        let grainLevellabel=notice[i].grainLevel||'粮食性质暂无'
        noticeList.push({
          value: notice[i].id,
          label: notice[i].number + '-' + notice[i].grainKind + '-' + foodNaturelabel + '-' + grainBelonglabel + '-' + grainLevellabel + '-' + (notice[i].primitiveNumber / 1000) + '吨',
          actualNumber: notice[i].actualNumber,
          primitiveNumber: notice[i].primitiveNumber,
        })
      }
    }
  })
  return noticeList
}

// 获取移库通知单的下拉选项，传入'入库','出库'
export function messageOptions1(type) {
  let noticeList = []
  httpToken({
    url: '/dropDown/notice1',
    method: 'post',
    data: qs.stringify({ type: type })
  }).then(res => {
    let notice = res.data.data
    for (let i = 0; i < notice.length; i++) {
      noticeList.push({
        value: notice[i].id,
        label: notice[i].number + '-' + notice[i].grainKind + '-' + notice[i].foodNature + '-' + notice[i].grainBelong + '-' + notice[i].grainLevel + '-' + (notice[i].primitiveNumber) / 1000 + '吨',
        actualNumber: notice[i].actualNumber,
        primitiveNumber: notice[i].primitiveNumber,
      })
    }
  })
  return noticeList
}

// 获取粮权所属的下拉选项
export function getBelongOptions() {
  let belongOptions = []
  httpToken({
    url: '/grain-owned/all',
    method: 'post'
  }).then(res => {
    // console.log(res.data.data)
    const belongList = res.data.data
    for (let j = 0; j < belongList.length; j++) {
      belongOptions.push(
        {
          value: belongList[j].id,
          label: belongList[j].companyName
        })
    }
  })
  return belongOptions
}
// 处理状态
export function dealstatus(status) {
  let rstatus
  switch (Number(status)) {
    case 1:
      rstatus = '入门登记';
      break;
    case 2:
      rstatus = '入库化验';
      break;
    case 3:
      rstatus = '毛重称重';
      break;
    case 3.1:
      rstatus = '入库化验';
      break;
    case 4:
      rstatus = '值仓管理';
      break;
    case 5:
      rstatus = '皮重称重';
      break;
    case 6:
      rstatus = '结算';
      break;
    case 7:
      rstatus = '出门登记';
      break;
    case -1:
      rstatus = '入门登记';
      break;
    case -2:
      rstatus = '皮重称重';
      break;
    case -3:
      rstatus = '值仓管理';
      break;
    case -4:
      rstatus = '毛重称重';
      break;
    case -5:
      rstatus = '出门登记';
      break;
  }
  return rstatus
}